import _ from 'lodash';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { Accordion, RequestHandlerScreen } from 'common-src/components/base';
import { apiRequest, HttpMethods } from 'common-src/features/rest';

import styles from './AlignmentData.module.scss';
import { ALIGNMENT_DATA_CONFIG, ALIGNMENT_DATA_OPTIONS } from './constants';

const AlignmentData = ({ patientId }) => {
  const navigate = useNavigate();

  const [data, setData] = useState({});
  const [isRequesting, setIsRequesting] = useState(true);

  useEffect(() => {
    apiRequest({
      endpoint: `patientGuideCmsAlignments/${patientId}/data`,
      method: HttpMethods.Get,
    })
      .then((res) => res.json())
      .then((data) => setData(data?.PAA || {}))
      .finally(() => setIsRequesting(false));
  }, []);

  if (isRequesting) {
    return <RequestHandlerScreen isRequesting requestingText="Pulling alignment data..." />;
  }

  const renderAccordionContent = (title) => {
    const config = ALIGNMENT_DATA_CONFIG[title];
    const fields = config.fields ?? [];

    return (
      <div className="p-16">
        {fields.map((field) => (
          <div key={field.key} className={[styles.row, 'flex-row', 'gap-8'].join(' ')}>
            <span className={[styles.label, 'font-w-500', 'm-r-16'].join(' ')}>{field.label}:</span>
            <span id={`${_.kebabCase(field.key)}-value`} className={styles.value}>
              {data[field.key] || 'N/A'}
            </span>
          </div>
        ))}
      </div>
    );
  };

  return (
    <div className={[styles.wrapper, 'flex-row', 'gap-24'].join(' ')}>
      <div className="flex-column gap-24 flex-1" style={{ height: 'max-content' }}>
        {[
          ALIGNMENT_DATA_OPTIONS.PAAF_BASIC,
          ALIGNMENT_DATA_OPTIONS.GUIDE_CLINICIAN,
          ALIGNMENT_DATA_OPTIONS.PAAF_CAREGIVER,
        ].map((value, index) => (
          <Accordion
            key={index}
            title={value.label}
            content={renderAccordionContent(value.label)}
            onNavigateClick={
              value.section
                ? () => navigate(`/dashboard-client/patients/details/${patientId}/${value.section}`)
                : null
            }
          />
        ))}
      </div>
      <div className="flex-column gap-24 flex-1" style={{ height: 'max-content' }}>
        {[
          ALIGNMENT_DATA_OPTIONS.PAAF_DEMENTIA,
          ALIGNMENT_DATA_OPTIONS.PAAF_PATIENT,
          ALIGNMENT_DATA_OPTIONS.PAAF_UNALIGNMENT,
        ].map((value, index) => (
          <Accordion
            key={index}
            title={value.label}
            content={renderAccordionContent(value.label)}
            onNavigateClick={
              value.section
                ? () => navigate(`/dashboard-client/patients/details/${patientId}/${value.section}`)
                : null
            }
          />
        ))}
      </div>
    </div>
  );
};

AlignmentData.propTypes = {
  patientId: PropTypes.number,
};

export default AlignmentData;
